export function sleep (millis: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, millis));
}

/** Momentarily yield running microtasks to allow the event loop to run and handle other
 * operations such as responding to health checks.
 */
export async function yieldToOtherWork () {
  await sleep(0);
}
